/* eslint-disable */
export default {
  _background: 'background',
  _background_with_rays: 'background_with_rays',
  _title: 'title',
  _green_dot_selected: 'green_dot_selected',
  _green_dot: 'green_dot',
  _bonus_round: 'bonus_round',
  _pop_bubbles_label: 'pop_bubbles_label',
  _next_round_button: 'next_round_button',
  _tiny_bubble: 'tiny_bubble',
  _bubble_fragment: 'bubble_fragment',
  _round_dial: 'round_dial',
  _time_dial: 'time_dial',
  _ray5: 'ray5',
  _ray6: 'ray6',
  _bubble: 'bubble',
  _bubble_large: 'bubble_large',
  _go_button: 'go_button',
  _number_box: 'number_box',
  _ray4: 'ray4',
  _ray3: 'ray3',
  _ray2: 'ray2',
  _ray1: 'ray1',
  _play_again_button: 'play_again_button',
  _try_again_button: 'try_again_button',
  _intro_background: 'intro_background',
  _sand: 'sand',
}